export { default } from './forEach.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/each.js
// module id = 379
// module chunks = 0